import { useHistory } from 'react-router-dom';
import AuthLayout from 'components/layout/auth-layout/auth-layout.component';
import mailSvg from 'assets/images/auth/mail.svg';
import { AuthButtonComponent } from '../components/auth-button/auth-button.component';

const PasswordRecovered = () => {
  const history = useHistory();

  return (
    <AuthLayout>
      <div className="flex align-items-start mt-8" style={{ letterSpacing: '0.5px' }}>
        <div className="mr-4">
          <img src={mailSvg} alt="key" />
        </div>

        <div className="flex-1">
          <p className="text-base font-semibold mb-2" style={{ color: '#050D43' }}>
            Check your email
          </p>
          <p style={{ color: '#6B7D8B' }}>We have sent a password recovery instruction to your email.</p>

          <div className="flex mt-7">
            <div className="border-bottom-2 border-gray-200 font-medium text-sm mr-5">Did not receive the email?</div>
            <AuthButtonComponent onClick={() => history.replace('/forgot-password')}>
              Try another email
            </AuthButtonComponent>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default PasswordRecovered;
